import React from "react";
import PropTypes from "prop-types";
import { VictoryChart, VictoryAxis, VictoryGroup, VictoryBar,
	VictoryLegend, VictoryContainer } from "victory";
import { injectIntl, intlShape } from "react-intl";

import AlmigTheme, { almigOrange, almigBlue } from "../grundelemente/AlmigTheme";

import { getBarParams, formatSecondsAsDuration } from "./AnalyseTools";

import { genDailyMessage } from "./DailyValuesHelpers";
import { checkDailyProps } from "../model/util/DailyValues";
import { compressorTicksShort } from "../model/util/Components";

class LastLeerlaufChart extends React.Component {
	
	static propTypes = {
		model: PropTypes.object.isRequired,
		timespan: PropTypes.object.isRequired,
		rtc: PropTypes.string.isRequired,
		compressors: PropTypes.arrayOf(PropTypes.object).isRequired,
		refresh: PropTypes.func.isRequired,
		intl: intlShape.isRequired
	};
	
	constructor(props, context) {
		super(props, context);
		checkDailyProps(props);
	}
	componentWillReceiveProps(nextProps) {
		checkDailyProps(nextProps);
	}
	render() {
		const { model, compressors, intl } = this.props;
		const pad_left = 58;
		const { bar_width, bar_offset, domain_padding } = getBarParams(model.data.length, pad_left, 2);

		return (
			<div>
				<VictoryChart
					theme={AlmigTheme}
					className="printableAlmigItem"
					domainPadding={{ x: domain_padding }}
					padding={{ left: pad_left, top: 20, bottom: 20 }}
					containerComponent={<VictoryContainer className="printableAlmigItem"/>}>
					<VictoryLegend x={pad_left} y={0}
						data={[
							{ name: intl.formatMessage({id: "Load"}), symbol: { fill: almigOrange }},
							{ name: intl.formatMessage({id: "No-load"}), symbol: { fill: almigBlue }}
						]} />
					<VictoryAxis tickValues={compressorTicksShort(model.data, compressors, intl)} />
					<VictoryAxis dependentAxis tickFormat={t => formatSecondsAsDuration(t, intl, 2)} />
					<VictoryGroup offset={bar_offset} style={{ data: { width: bar_width }}}>
						<VictoryBar data={model.data} x={d => d.cindex.toString()} y="lastlauf_s" color={almigOrange} />
						<VictoryBar data={model.data} x={d => d.cindex.toString()} y="leerlauf_s" color={almigBlue} />
					</VictoryGroup>
				</VictoryChart>
				{genDailyMessage(model)}
			</div>
		);
	}
}

export default injectIntl(LastLeerlaufChart);
